import React, { useEffect, useState } from 'react'
import {
  FibaDropdown, FibaInput, FibaInputNumber,
  FibaTab, FibaTabStrip, FibaTextArea,
  Form,
} from '../components'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Field } from '@progress/kendo-react-form'
import Tab1 from './Tabs/Tab1'

const ProductDetail = () => {
  const { t } = useTranslation()
  const { id } = useParams()
  const [showstate, setShowstate] = useState(false);

  useEffect(() => {
    if (!showstate) {
      setShowstate(true)
    }
  }, [showstate])

  return (
    <div className='mx-auto max-w-7xl'>
      <FibaTab tabPosition={'right'}>
        <FibaTabStrip title={'Дэлгэрэнгүй мэдээлэл'}>
          <Form
            initialValues={{ sale: 0, statusid: 1 }}
            detail={'ml000015'}
            create={'ml000012'}
            update={'ml000013'}
            id={id}
          >
            <div className="grid gap-4 md:grid-cols-2 sm:grid-cols-1">

              {/* <div className='col-span-full'>
                <Field
                  name={'photo1'}
                  component={FibaPhotoInput}
                  label={t('photo1')}
                />
              </div> */}
              <Field
                name={'name'}
                component={FibaInput}
                label={t('name')}
                required={true}
              />
              <Field
                name={'name2'}
                component={FibaInput}
                label={t('name2')}
                required={true}
              />
              <Field
                name={'type'}
                component={FibaDropdown}
                label={t('type')}
                required={true}
                dictCode={'DIC_100'}
              />
              <Field
                name={'statusid'}
                component={FibaDropdown}
                label={t('status')}
                required={true}
                dictCode={'DIC_101'}
              />
              <Field
                name={'price'}
                component={FibaInputNumber}
                label={t('price')}
                required={true}
              />
              <Field
                name={'sale'}
                component={FibaInputNumber}
                label={t('sale')}
                required={true}
                max={100}
                min={0}
              />
              <Field
                name={'sizetype'}
                component={FibaDropdown}
                label={t('sizetype')}
                required={true}
                dictCode={'DIC_102'}
              />
              <div className='col-span-full'>
                <div className="grid gap-4 md:grid-cols-2 sm:grid-cols-1">
                  <Field
                    name={'description'}
                    component={FibaTextArea}
                    label={t('description')}
                    required={true}
                    rows={8}
                  />
                  <Field
                    name={'description2'}
                    component={FibaTextArea}
                    label={t('description2')}
                    required={true}
                    rows={8}
                  />
                </div>
              </div>

            </div>
          </Form>
        </FibaTabStrip>
        <FibaTabStrip title={'Бүтээгдэхүүний өнгө/хэмжээ/тоо'}>
          <Tab1 productid={id} />
        </FibaTabStrip>
      </FibaTab>

    </div>
  )
}

export default ProductDetail